import React from 'react'
import Image from 'next/image'
import AppStoreIcon from '../svg/AppStoreIcon'
import { DownloadAPKIcon } from '../svg/DownloadAPKIcon'
import {
  TIPSY_APK_URL,
  TIPSY_APP_STORE_URL,
  TIPSY_PLAY_STORE_URL,
  TIPSY_RUSTORE_URL,
} from '@/constant/download'
import Rustore_icon from '@/icons/download/Rustore_icon.svg'
import useI18n from 'Hooks/useI18n'
import GooglePlayIcon from 'Comps/svg/GooglePlayIcon'
import rustoreQr from '@/icons/download/download_icon_rustore.png'

const DownloadQRModal = ({ country }: { country?: string }) => {
  const { t } = useI18n()

  return (
    <div className="flex flex-col items-center justify-center px-7 pb-[29px] pt-[21px] text-white">
      <h3 className="mb-[5px] text-lg font-semibold leading-[21px] text-white">
        {t('Get the Tipsy app')}
      </h3>
      <p className="mb-3 text-sm leading-4 text-white/50">
        {t('Scan QR code to download Tipsy')}
      </p>
      <div className="flex gap-4">
        <div>
          <Image
            unoptimized
            src="/app/app-qrcode.png"
            width={200}
            height={200}
            alt="Download QR code"
            className="mb-[14px]"
          />
          <div className="flex flex-col items-center gap-1.5">
            <a
              href={TIPSY_APP_STORE_URL}
              target="_blank"
              className="flex h-12 w-[178px] items-center justify-center gap-1 rounded-lg border border-white/10 bg-white/5 transition hover:border-white/70"
            >
              <AppStoreIcon iconSize={24} />
              <div className="-mx-[40px] flex scale-50 flex-col">
                <p className="min-w-[160px] whitespace-nowrap text-[20px] leading-[24px] text-white/50">
                  {t('Download')}
                </p>
                <p className="min-w-[160px] whitespace-nowrap text-[30px] leading-[36px] text-white">
                  App Store
                </p>
              </div>
            </a>
          </div>
        </div>
        {country === 'RU' && (
          <div>
            <Image
              unoptimized
              src={rustoreQr}
              width={200}
              height={200}
              alt="Download on the Rustore QR code"
              className="mb-[14px]"
            />
            <div className="flex flex-col items-center gap-1.5">
              <a
                href={TIPSY_RUSTORE_URL}
                target="_blank"
                className="flex h-12 w-[178px] items-center justify-center gap-1 rounded-lg border border-white/10 bg-white/5 transition hover:border-white/70"
              >
                <Rustore_icon width={24} height={24} />
                <div className="-mx-[40px] flex scale-50 flex-col">
                  <p className="min-w-[160px] whitespace-nowrap text-[20px] leading-[24px] text-white/50">
                    {t('Download')}
                  </p>
                  <p className="min-w-[160px] whitespace-nowrap text-[30px] leading-[36px] text-white">
                    Rustore
                  </p>
                </div>
              </a>
            </div>
          </div>
        )}
        <div>
          <Image
            unoptimized
            src="/app/app-qrcode-google-play.png"
            width={200}
            height={200}
            alt="Download on the Google Play QR code"
            className="mb-[14px]"
          />
          <div className="mt-3 flex flex-col items-center gap-1.5">
            <a
              href={TIPSY_PLAY_STORE_URL}
              target="_blank"
              className="flex h-12 w-[178px] items-center justify-center gap-1 rounded-lg border border-white/10 bg-white/5 transition hover:border-white/70"
            >
              <GooglePlayIcon iconSize={24} />
              <div className="-mx-[40px] flex scale-50 flex-col">
                <p className="min-w-[160px] whitespace-nowrap text-[20px] leading-[24px] text-white/50">
                  {t('Download')} (SFW)
                </p>
                <p className="min-w-[160px] whitespace-nowrap text-[30px] leading-[36px] text-white">
                  Google Play
                </p>
              </div>
            </a>
          </div>
        </div>
        <div>
          <Image
            unoptimized
            src="/app/app-qrcode-apk.png"
            width={200}
            height={200}
            alt="Download QR code"
            className="mb-[14px]"
          />
          <div className="mt-3 flex flex-col items-center gap-1.5">
            <a
              href={TIPSY_APK_URL}
              target="_blank"
              className="flex h-12 w-[178px] items-center justify-center gap-1 rounded-lg border border-white/10 bg-white/5 transition hover:border-white/70"
            >
              <DownloadAPKIcon iconSize={24} />
              <div className="-mx-[40px] flex scale-50 flex-col">
                <p className="min-w-[160px] whitespace-nowrap text-[20px] leading-[24px] text-white/50">
                  {t('Download')}
                </p>
                <p className="min-w-[160px] whitespace-nowrap text-[30px] leading-[36px] text-white">
                  APK
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DownloadQRModal
